import axios from 'axios'
import { Message, MessageBox } from 'element-ui';
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  timeout: 20000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== "success" && !response.config.url.includes('/drm/hls/') && !response.config.url.includes('.m3u8')) {
      // 错误提示
      console.log('ERROR', res)

      // 未登录或cookie已过期
      if (res.subCode === "cookie.not.found" || res.subCode === "token.expire") {
        MessageBox.confirm('当前未登录或会话已过期, 是否跳转登录?', '系统消息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          location.href = `/account/login`
        }).catch(() => { })
      } else if (res.error) {
        Message({ message: res.message || res.error, type: 'error' });
      } else {
        Message({ message: `[${res.code}]${(res.subCode || res.msg)}`, type: 'error' })
      }
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return Promise.resolve(res)
    }
  },
  error => {
    console.log('err' + error)
    Message({ message: `[error]${error}`, type: 'error' })
    return Promise.reject(error)
  }
)

export default service
